import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function MarketingLayout() {
  return (
    <div className="grain min-h-screen bg-black">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
